"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastIconContainer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
const ToastIconContainer = (0, _styled.default)("div")`
    // Ensure we wrap the Icon itself with no extra default spacing.
    display: inline-flex;

    margin: ${_designTokens.space.space30} 0 ${_designTokens.space.space30} ${_designTokens.space.space30};

    color: ${_ref => {
  let {
    iconColor
  } = _ref;
  return iconColor;
}};
`;
exports.ToastIconContainer = ToastIconContainer;
//# sourceMappingURL=ToastIconContainer.js.map